(function () {
  // 店舗お気に入り (Multilikes metaobject_type: 'store')
  // 対象ボタン: .store-favorite-btn[data-store-id]
  //   - 店舗一覧 (sections/shoplist-page.liquid) … アイコンのみ
  //   - 商品詳細 アイテム詳細テーブル (snippets/custom-tablelist-new.liquid) … PCはラベル付き
  // 設定は layout/theme.liquid の window.__multilikesFavConfig を共用。
  // 実装は assets/multilikes-brand-favorite.js と同一パターン (store 版)。
  if (window.__multilikesStoreFavWired) {
    if (typeof window.__multilikesStoreFavInit === 'function') {
      window.__multilikesStoreFavInit();
    }
    return;
  }
  window.__multilikesStoreFavWired = true;

  var cfg = window.__multilikesFavConfig || {};
  var apiBase = cfg.apiBase || '/apps/multilikes-endpoint';
  var isLoggedIn = !!cfg.isLoggedIn;
  var customerId = cfg.customerId || null;
  var loginUrl = cfg.loginUrl || '/account/login';

  var metaobjectType = 'store';

  function setState(btn, favorited) {
    btn.classList.toggle('is-favorited', favorited);
    btn.setAttribute('aria-pressed', String(favorited));
    // ラベル付きボタン (商品詳細テーブル) はテキストと aria-label も切替。
    // アイコンのみのボタン (店舗一覧) は data-label-* を持たないので現状維持。
    var textOn = btn.dataset.labelOn;
    var textOff = btn.dataset.labelOff;
    var next = favorited ? textOn : textOff;
    if (next) {
      var label = btn.querySelector('.store-favorite-btn__label');
      if (label) label.textContent = next;
      btn.setAttribute('aria-label', next);
    }
  }

  // 同じ store id を持つ全ボタンに状態を反映する (ALLタブ/地域タブ等の重複描画対応)
  function setStateForStore(storeId, favorited) {
    document.querySelectorAll('.store-favorite-btn[data-store-id="' + storeId + '"]').forEach(function (b) {
      setState(b, favorited);
    });
  }

  // 初期状態 (お気に入り済み id マップ) は1回だけ取得して使い回す
  var initialStatesPromise = null;
  function getInitialStates() {
    if (initialStatesPromise) return initialStatesPromise;
    if (!isLoggedIn) {
      initialStatesPromise = Promise.resolve({});
      return initialStatesPromise;
    }
    var params = new URLSearchParams({
      metaobject_type: metaobjectType,
      mode: 'customer_wishlist',
      customer_id: customerId,
      limit: '250'
    });
    initialStatesPromise = fetch(apiBase + '?' + params.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.error) throw new Error(j.error);
        var map = {};
        (j.data || []).forEach(function (item) { map[String(item.id)] = true; });
        return map;
      })
      .catch(function (e) {
        console.error('[Multilikes] 店舗お気に入り状態の取得に失敗:', e);
        return {};
      });
    return initialStatesPromise;
  }

  function postToggle(storeId, currentlyFavorited) {
    var body = new URLSearchParams({
      target_type: 'metaobject',
      customer_id: customerId,
      action: currentlyFavorited ? 'remove' : 'add',
      metaobject_type: metaobjectType,
      metaobject_id: storeId
    });
    return fetch(apiBase, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: body.toString()
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.error) throw new Error(j.error);
        return j.data;
      });
  }

  function bind(btn) {
    if (btn.dataset.storeFavBound === 'true') return;
    btn.dataset.storeFavBound = 'true';

    if (isLoggedIn) {
      getInitialStates().then(function (map) {
        if (map[btn.dataset.storeId]) setState(btn, true);
      });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!isLoggedIn) {
        window.location.href = loginUrl;
        return;
      }

      var id = btn.dataset.storeId;
      if (!id) return;

      var currently = btn.classList.contains('is-favorited');
      // 同じ id を持つ全ボタンを楽観的更新 + disable (連打防止)
      var sameBtns = document.querySelectorAll('.store-favorite-btn[data-store-id="' + id + '"]');
      sameBtns.forEach(function (b) { b.disabled = true; });
      setStateForStore(id, !currently);

      postToggle(id, currently)
        .then(function (data) {
          // サーバレスポンスの真値で UI を確定
          setStateForStore(id, !!data.isInWishlist);
        })
        .catch(function (err) {
          console.error('[Multilikes] 店舗お気に入り更新に失敗:', err);
          setStateForStore(id, currently);
          alert('お気に入りの更新に失敗しました。時間をおいて再度お試しください。');
        })
        .finally(function () {
          sameBtns.forEach(function (b) { b.disabled = false; });
        });
    });
  }

  function init() {
    document.querySelectorAll('.store-favorite-btn').forEach(bind);
  }

  window.__multilikesStoreFavInit = init;

  // 動的に差し替えられる場合に再バインドできるよう Observer も用意
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          init();
          break;
        }
      }
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
